// extracted by mini-css-extract-plugin
export default {"a11yFocus":"jYe5en","a11YFocus":"jYe5en","submitButton":"XDrALg","enterPasswordContainer":"XN7Z_m"};